<template>
    <div :class="groupClass">
        <button type="button" @click="toggleOpen">
            <common-icon :name="icon" size="huge"></common-icon>

            <transition name="fade" mode="in-out">
                <span v-show="!showText">
                    {{ label }}
                    <common-icon name="menu-arrow" size="large"></common-icon>
                </span>
            </transition>
        </button>

        <app-main-menu-item
            v-for="item in items"
            v-show="item.isVisible"
            :key="item.label"
            v-bind="item"
            :showText="showText"
            :isNested="true"
        ></app-main-menu-item>
    </div>
</template>

<script>
    import { isRouteNameEqual } from '~/helpers'
    import AppMainMenuItem from 'components/layouts/components/main-layout/AppMainMenuItem'

    export default {
        components: {
            AppMainMenuItem,
        },

        props: {
            label: { type: String, required: true },
            icon: { type: String, required: true },
            items: { type: Array, required: true },
            showText: { type: Boolean, default: false },
        },

        data() {
            return {
                isOpen: false,
            }
        },

        computed: {
            groupClass() {
                return {
                    'app-main-menu__group': true,
                    'app-main-menu__group--is-open': this.isOpen,
                }
            },
        },

        methods: {
            toggleOpen() {
                this.isOpen = !this.isOpen
            },
            isOpenGroup() {
                this.isOpen = this.items.some((item) =>
                    item.route ? isRouteNameEqual(item.route.name, this.$route.name, 3) : false,
                )
            },
        },

        watch: {
            $route() {
                this.isOpenGroup()
            },

            showText() {
                this.isOpenGroup()
            },
        },

        mounted() {
            this.isOpenGroup()
        },
    }
</script>
